import { Text } from '@cinch-labs/design-system'
import { Panel } from '@cinch-nx/landing-ui-shared'
import { useAnalytics } from '@cinch-nx/shared-analytics'
import { SVG } from '@cinch-nx/shared-ui'
import cx from 'classnames'

import Mail from '../../assets/mail.svg'
import Phone from '../../assets/phone.svg'
import Smartphone from '../../assets/smartphone.svg'
import WhatsApp from '../../assets/whats-app.svg'
import { handleTrackingClick } from '../../helpers/helpers'
import styles from './contact-card.module.css'

export interface ContactCardProps {
  svgType: string
  heading: string
  body: string
  cta: string
  category: string
  href?: string
  shouldHideOnDesktop?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SvgComponent: Record<string, React.FC<any>> = {
  mail: Mail,
  phone: Phone,
  smartphone: Smartphone,
  whatsapp: WhatsApp,
} as const

const ContactCard = ({
  svgType,
  heading,
  body,
  cta,
  category,
  href,
  shouldHideOnDesktop = false,
}: ContactCardProps) => {
  const { trackEvent } = useAnalytics()

  return (
    <Panel
      className={cx(styles.panel, shouldHideOnDesktop && styles.hiddenDesktop)}
      classNames={{ body: styles.panelFlex }}
      isPadded
    >
      <div className={styles.iconWrapper}>
        <SVG
          children={SvgComponent[svgType.toLocaleLowerCase()]}
          width={32}
          height={32}
        />
      </div>

      <div className={styles.textContainer}>
        <h4 className={styles.panelHeading}>{heading}</h4>

        <div className={styles.textWrapper}>
          <Text fontSize="xs" fontWeight="book">
            {body}
          </Text>
        </div>

        <a
          href={`${href ? href : cta}`}
          aria-label={cta}
          className={styles.link}
          onClick={() =>
            handleTrackingClick(trackEvent, {
              eventName: 'Support - click contact card',
              label: cta,
              category: category,
            })
          }
        >
          {cta}
        </a>
      </div>
    </Panel>
  )
}

export default ContactCard
